#version 300 es
precision highp float;

// Each point is one 8px ASCII cell. "position" holds the cell centre in pixels.
in vec2 position;
in vec3 aRandom;

uniform vec2 uResolution;
uniform sampler2D uTexture;
uniform float uScrollFade; // 0 = particles in place, 1 = all gone
uniform float uTime;

// Tunables
uniform float uStagger;     // how staggered particle start times are
uniform float uDriftX;      // wind (fraction of screen)
uniform float uDriftY;
uniform float uRadius;      // base orbit radius (fraction of screen)
uniform float uRadiusVar;   // extra random orbit radius
uniform float uOrbitSpeed;  // base orbit angular speed
uniform float uOrbitVar;    // extra random orbit speed
uniform float uJitter;      // buzz in pixels
uniform float uScatter;     // scatter distance (fraction of screen diagonal)
uniform float uGatherEnd;   // t at which a particle starts fading
uniform float uFadeLength;  // length of the fade, in particle timeline units
uniform float uPointSize;   // particle size in px

flat out vec3 vColor;
out float vAlpha;

void main() {
  vec2 res = uResolution;
  vColor = texture(uTexture, floor(position / 16.0) * 16.0 / res).rgb;

  // Staggered timeline: partly spatial (a soft wave across the screen), partly random
  float delay = mix(position.x / res.x * 0.5 + position.y / res.y * 0.5, aRandom.x, 0.5);
  float t = clamp((uScrollFade - delay * uStagger) / (1.0 - uStagger), 0.0, 1.0);
  float move = t * t * (3.0 - 2.0 * t);
  float fade = smoothstep(uGatherEnd, min(uGatherEnd + uFadeLength, 1.0), t);

  // Slow, smooth individual orbit; no high-frequency jitter
  float ang = uTime * (uOrbitSpeed + aRandom.y * uOrbitVar) + aRandom.z * 6.2831;
  float radius = (uRadius + uRadiusVar * aRandom.y) * min(res.x, res.y) * move;
  vec2 orbit = vec2(cos(ang), sin(ang * 1.3)) * radius;
  vec2 jitter = vec2(sin(uTime * 3.0 + aRandom.z * 40.0), cos(uTime * 2.5 + aRandom.y * 40.0)) * uJitter * move;

  // Shared wind plus a random outward direction per particle
  vec2 wind = vec2(uDriftX, uDriftY) * res * move * (0.5 + aRandom.y);
  float dir = aRandom.z * 6.2831 + aRandom.x * 3.0;
  vec2 scatter = vec2(cos(dir), sin(dir)) * uScatter * length(res) * 0.25 * move * (0.5 + aRandom.y);

  vec2 pos = position + orbit + jitter + wind + scatter;

  vAlpha = 1.0 - fade;
  gl_Position = vec4(pos / res * 2.0 - 1.0, 0.0, 1.0);
  gl_PointSize = fade >= 1.0 ? 0.0 : uPointSize * (1.0 - 0.4 * fade);
}
